import styled from 'styled-components';
import {GameJackpotBarLogoDefaultBox} from './game-jackpot-bar-logo.default.box';

export const GameJackpotBarLogoMrgreenBox = styled(GameJackpotBarLogoDefaultBox)<{isOptInStatus?: boolean}>`    
    margin-left: ${({isMobilePortrait}) => isMobilePortrait ? '5rem' : '1.2rem'};
    background-size: ${({isMobilePortrait}) => isMobilePortrait ? '45%' : '35%'};
    background-position-y: 55%;
`;